import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from '../services/general.service';
// import { IDropdownSettings } from 'ng-multiselect-dropdown';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-add-auditer',
  templateUrl: './add-auditer.component.html',
  styleUrls: ['./add-auditer.component.scss']
})
export class AddAuditerComponent implements OnInit {
  AddAuditerForm: FormGroup;
  clients: any;
  clientstofilter: any;
  dataSource: any;
  displayedColumns: string[] = [
    "Name",
    "Email",
    "action",
  ];
  data: object[] = [];
  update: boolean;
  editmode: boolean;
  ClusterId: any;
  ClientId: any;
  dropdownList = [];
  selectedItems = [];
  AllBranchs: any[]=[];
  Auditers: any;
  Auditerstofilter: any;
  AuditerBranch: any[]=[];
  BranchsForEdit: any[]=[];
  AuditerId: any;
  UserInfo: any;
  // dropdownSettings :IDropdownSettings;
  constructor(private _formBuilder: FormBuilder,  public GeneralService: GeneralService
    ) { 
       this.UserInfo=JSON.parse(localStorage.getItem('currentuser'));
       this.ClientId=this.UserInfo.clientid;
    } 


    initForm() {
      this.AddAuditerForm = this._formBuilder.group({
        AuditerName: [ '', Validators.required],
        Email: ['', Validators.required],
        Branchs:[[],Validators.required]
      });
    }
    GetAllBranchs(){
    this.GeneralService.getBranchByClientId(this.ClientId).then(res=>{
      this.AllBranchs=res;
    })
    }
    getallAuditer(){
      const ClientId=this.ClientId
      this.Auditers=[];
      this.GeneralService.getAuditerbyclientid(ClientId).then(auditers=>{
        this.Auditers=auditers;
        this.Auditerstofilter=auditers
        console.log(this.Auditers)
      })
    }
    get fc() {
      return this.AddAuditerForm.controls;
    }

  

    ngOnInit() {
      // this.dropdownSettings = {
      //   singleSelection: false, 
      //   idField: 'id',
      //   textField: 'name',
      //   selectAllText: 'Select All',
      //   unSelectAllText: 'UnSelect All',
      //   itemsShowLimit: 3,
      //   allowSearchFilter: true
      // };
      this.editmode=false;
      this.initForm();
      this.getallAuditer();
      this.GetAllBranchs();
    }
    InsertAuditer(){
      this.AuditerBranch=[]
      this.AddAuditerForm.get("Branchs").value.forEach(element => {
        this.AuditerBranch.push(element)
      });
      const data= {
    "name":this.AddAuditerForm.get("AuditerName").value,
    "email":this.AddAuditerForm.get("Email").value,
    "clientid":this.ClientId,
    "branchesid":this.AuditerBranch,
    "role":"auditer",
      }
      this.GeneralService.addAuditerForClient(data).then(res=>{
        this.getallAuditer();
        Swal.fire({
          icon: "success",
          title: "Success Add Auditor",
          showConfirmButton: false,
          timer:1000
        });
                this.AddAuditerForm.reset();
                this.AuditerBranch = [];
    
      })
    }
    addAuditer(){
      console.log(this.AddAuditerForm.value)
      if (this.AddAuditerForm.status == "VALID") {
        if (this.update == true) {
          this.UpdateAuditer();
        } 
        else {
          this.InsertAuditer()
        }
      }
       else {
        this.AddAuditerForm.markAllAsTouched();
      }
    }
    
    Edit(item){
    console.log(item)
    this.BranchsForEdit=[];
    this.AuditerId=item.id
    this.editmode=true
    this.update=true
    this.AddAuditerForm.get("AuditerName").setValue(item.name)
    this.AddAuditerForm.get("Email").setValue(item.email)
    item.branchesid.forEach((element) => {
      const branch = this.AllBranchs.filter((x) => x.id == element);
      if(branch.length!=0){
        this.BranchsForEdit.push(branch[0].id);
      }
    }); 
    this.AddAuditerForm.get('Branchs').setValue(this.BranchsForEdit)

    
    }
    
    UpdateAuditer(){

      let OldEmail;
const AuditerEmail = this.Auditers.filter(x=>x.id==this.AuditerId)[0].email
  if(AuditerEmail==this.AddAuditerForm.get('Email').value){
    OldEmail=AuditerEmail
  }
  else{
    OldEmail=null
  }
      this.AuditerBranch=[]
      this.AddAuditerForm.get("Branchs").value.forEach(element => {
        this.AuditerBranch.push(element)
      });
      console.log(this.AuditerBranch)
      const data= {
    "name":this.AddAuditerForm.get("AuditerName").value,
    "email":this.AddAuditerForm.get("Email").value,
    "clientid":this.ClientId,
    "branchesid":this.AuditerBranch,
    "role":"auditer",
      }
          this.GeneralService.UpdateAuditer(data,this.AuditerId,OldEmail).then((res)=>{
            this.AddAuditerForm.reset() 
                Swal.fire({
              icon: "success",
              title: "Success Update Auditor",
              showConfirmButton: false,
              timer:1000
            });
            this.BranchsForEdit=[];
            this.Auditers=[];
            this.AuditerBranch=[];
            this.editmode=false;
            this.update=false
          }).then(r=>{
            this.getallAuditer();
          })
    }
    
    DeleteAuditer(item){
    Swal.fire({
      title: " Warning !",
      text: "Are you sure to delete this Auditer",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#7364f6',
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
      cancelButtonText: "Back",
    }).then((result) => {
      if (result.isConfirmed) {
        this.GeneralService.DelUser(item.id).subscribe(async success => {
          if (success) {
            try {
              await this.GeneralService.deleteUserFromAuth(item.email);
              Swal.fire({
                icon: "success",
                title: "Success User Deleted",
                showConfirmButton: false,
                timer:1000
              });
              this.getallAuditer();
            } catch (error) {
              console.error("Error deleting user from Auth:", error);
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "User deleted from database but failed to delete from authentication",
              });
            }
          
          } else {
            console.log("Auditor could not be removed due to quota limits or other errors.");
          }
        });
      } else {
        // Swal.fire(
        //   'Your appointment still active ',
        // );
      }
    });
    }
    

}
